import { useState } from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import StudentEditModal from "./StudentEditModal";
import DeleteStudentModal from "./DeleteStudentModal";

export const StudentMoreButton = ({ student }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const handleCloseMenu = () => {
    setMenuOpen(false);
  };

  const handleToggleMenu = (event, student) => {
    setMenuOpen(true);
    setDeleteTarget({ student });
    setMenuPosition({ x: event.clientX, y: event.clientY });
  };

  const styles = {
    button: {
      background: "none",
      border: "none",
      cursor: "pointer",
      height: "20px",
      width: "20px",
    },
    menu: {
      position: "absolute",
      left: `${menuPosition.x}px`,
      top: `${menuPosition.y}px`,
      background: "#fff",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      borderRadius: "5px",
      padding: "10px",
      zIndex: 1000,
    },
    menuItem: {
      padding: "8px 12px",
      cursor: "pointer",
      fontSize: "14px",
      color: "#333",
      borderBottom: "1px solid #eee",
    },
    menuItemLast: {
      padding: "8px 12px",
      cursor: "pointer",
      fontSize: "14px",
      color: "#333",
    },
  };

  return (
    <div>
      <button
        style={styles.button}
        onClick={(event) => handleToggleMenu(event, student)}
      >
        <span style={{ fontWeight: 900, color: "#000000", fontSize: "20px" }}>
          ⋮
        </span>
      </button>
      {menuOpen && (
        <ClickAwayListener onClickAway={handleCloseMenu}>
          <div style={styles.menu}>
            <div
              style={styles.menuItem}
              onClick={() => {
                setIsEditModalOpen(true);
                handleCloseMenu();
              }}
            >
              학생 편집
            </div>
            <div
              style={styles.menuItemLast}
              onClick={() => {
                setIsDeleteModalOpen(true);
                handleCloseMenu();
              }}
            >
              학생 삭제
            </div>
          </div>
        </ClickAwayListener>
      )}

      {isDeleteModalOpen && deleteTarget && (
        <DeleteStudentModal
          deleteTarget={deleteTarget}
          setDeleteTarget={setDeleteTarget}
          setIsDeleteModalOpen={setIsDeleteModalOpen}
        ></DeleteStudentModal>
      )}

      {isEditModalOpen && (
        <StudentEditModal
          setIsEditModalOpen={setIsEditModalOpen}
          student={student}
        ></StudentEditModal>
      )}
    </div>
  );
};

export default StudentMoreButton;
